import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import Sports from "../Sports";
import { moveFormatter } from "../../fomatters/BooleanFormatter";

function WagerTypesOnline(props) {
  let IdProfile = props.Profile.IdProfile;

  const [sport, setSport] = useState();
  const onSportChanged = useCallback((sport) => {
    setSport(sport);
  }, []);

  return (
    <div className="flex flex-col gap-4 h-max">
      <div className="!gap-4 horizontal-options">
        <Sports setIdSportOnMem={onSportChanged} />
      </div>
      <Crud
        title="Wager Type Online"
        getUrl={sport ? () =>
          `/Profile/WagerTypeSport_GetList?idProfile=${IdProfile}&idSport=${sport}`
        : null}
        // UPDATE
        updateUrl={() => "/Profile/WagerTypeSport_Update"}
        updateParams={(
          { userId },
          { idWagerType, online, local, description, IdWagerType, Online, Local, Description }
        ) => ({
          IdWagerType: idWagerType ?? IdWagerType,
          IdSport: sport,
          Description: description ?? Description,
          Online: String(online ?? Online) === "true" ? true : false,
          Local: String(local ?? Local) === "true" ? true : false,
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idWagerType"
        >
          IdWagerType
        </TableHeaderColumn>
        <TableHeaderColumn dataField="description">
          Wager Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="local"
          dataAlign="center"
          dataFormat={moveFormatter}
          editable={{
            type: "checkbox",
          }}
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="online"
          dataAlign="center"
          dataFormat={moveFormatter}
          editable={{
            type: "checkbox",
          }}
        >
          Online
        </TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default WagerTypesOnline;
